/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Color_WhiteInputs */

const en_orders_review_color_white = /** @type {(inputs: Orders_Review_Color_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White`)
};

const es_orders_review_color_white = /** @type {(inputs: Orders_Review_Color_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blanco`)
};

/**
* | output |
* | --- |
* | "White" |
*
* @param {Orders_Review_Color_WhiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_color_white = /** @type {((inputs?: Orders_Review_Color_WhiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Color_WhiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_color_white(inputs)
	return es_orders_review_color_white(inputs)
});